export const fehb = {
  Z24: {
    name: 'Aetna Advantage',
    option: 'Advantage',
    type: 'Self',
    biweeklyTotal: 212.93,
    biweeklyGov: 159.7,
    biweeklyEmp: 53.23,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  Z25: {
    name: 'Aetna Advantage',
    option: 'Advantage',
    type: 'Self & Family',
    biweeklyTotal: 564.25,
    biweeklyGov: 423.19,
    biweeklyEmp: 141.06,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  Z26: {
    name: 'Aetna Advantage',
    option: 'Advantage',
    type: 'Self Plus One',
    biweeklyTotal: 468.44,
    biweeklyGov: 351.33,
    biweeklyEmp: 117.11,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  N61: {
    name: 'Aetna Direct',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 307.44,
    biweeklyGov: 230.58,
    biweeklyEmp: 76.86,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  N62: {
    name: 'Aetna Direct',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 775.32,
    biweeklyGov: 581.49,
    biweeklyEmp: 193.83,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  N63: {
    name: 'Aetna Direct',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 674.24,
    biweeklyGov: 505.68,
    biweeklyEmp: 168.56,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F51: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 537.79,
    biweeklyGov: 298.08,
    biweeklyEmp: 239.71,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F52: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1226.24,
    biweeklyGov: 714.23,
    biweeklyEmp: 512.01,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F53: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1214.09,
    biweeklyGov: 650.0,
    biweeklyEmp: 564.09,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F54: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 540.44,
    biweeklyGov: 298.08,
    biweeklyEmp: 242.36,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F55: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 1237.58,
    biweeklyGov: 714.23,
    biweeklyEmp: 523.35,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F56: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 1213.28,
    biweeklyGov: 650.0,
    biweeklyEmp: 563.28,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _224: {
    name: 'Aetna HealthFund HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 433.28,
    biweeklyGov: 298.08,
    biweeklyEmp: 135.2,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _225: {
    name: 'Aetna HealthFund HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 955.72,
    biweeklyGov: 714.23,
    biweeklyEmp: 241.49,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _226: {
    name: 'Aetna HealthFund HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 937.01,
    biweeklyGov: 650.0,
    biweeklyEmp: 287.01,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  AS1: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 379.74,
    biweeklyGov: 284.81,
    biweeklyEmp: 94.93,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  AS2: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 898.09,
    biweeklyGov: 673.57,
    biweeklyEmp: 224.52,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  AS3: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 816.43,
    biweeklyGov: 612.32,
    biweeklyEmp: 204.11,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LS1: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 363.76,
    biweeklyGov: 272.82,
    biweeklyEmp: 90.94,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LS2: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 836.63,
    biweeklyGov: 627.47,
    biweeklyEmp: 209.16,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LS3: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 782.06,
    biweeklyGov: 586.55,
    biweeklyEmp: 195.51,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  Y81: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 325.74,
    biweeklyGov: 244.31,
    biweeklyEmp: 81.43,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  Y82: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 770.36,
    biweeklyGov: 577.77,
    biweeklyEmp: 192.59,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  Y83: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 700.34,
    biweeklyGov: 525.26,
    biweeklyEmp: 175.08,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  JS4: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 622.32,
    biweeklyGov: 298.08,
    biweeklyEmp: 324.24,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JS5: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 1420.65,
    biweeklyGov: 714.23,
    biweeklyEmp: 706.42,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JS6: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 1406.63,
    biweeklyGov: 650.0,
    biweeklyEmp: 756.63,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JS1: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 647.54,
    biweeklyGov: 298.08,
    biweeklyEmp: 349.46,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JS2: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1476.09,
    biweeklyGov: 714.23,
    biweeklyEmp: 761.86,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JS3: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1461.47,
    biweeklyGov: 650.0,
    biweeklyEmp: 811.47,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G54: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 476.51,
    biweeklyGov: 298.08,
    biweeklyEmp: 178.43,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G55: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 1091.34,
    biweeklyGov: 714.23,
    biweeklyEmp: 377.11,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G56: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 1069.97,
    biweeklyGov: 650.0,
    biweeklyEmp: 419.97,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G51: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 626.74,
    biweeklyGov: 298.08,
    biweeklyEmp: 328.66,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G52: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1429.57,
    biweeklyGov: 714.23,
    biweeklyEmp: 715.34,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G53: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1415.44,
    biweeklyGov: 650.0,
    biweeklyEmp: 765.44,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  WQ1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 660.71,
    biweeklyGov: 298.08,
    biweeklyEmp: 362.63,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  WQ2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1604.18,
    biweeklyGov: 714.23,
    biweeklyEmp: 889.95,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  WQ3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1588.29,
    biweeklyGov: 650.0,
    biweeklyEmp: 938.29,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  WF1: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 360.45,
    biweeklyGov: 270.34,
    biweeklyEmp: 90.11,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  WF2: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 852.46,
    biweeklyGov: 639.35,
    biweeklyEmp: 213.11,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  WF3: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 774.97,
    biweeklyGov: 581.23,
    biweeklyEmp: 193.74,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LU1: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 393.17,
    biweeklyGov: 294.88,
    biweeklyEmp: 98.29,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LU2: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 904.31,
    biweeklyGov: 678.23,
    biweeklyEmp: 226.08,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LU3: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 845.33,
    biweeklyGov: 634.0,
    biweeklyEmp: 211.33,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  VD1: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 356.02,
    biweeklyGov: 267.02,
    biweeklyEmp: 89.0,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  VD2: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 841.99,
    biweeklyGov: 631.49,
    biweeklyEmp: 210.5,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  VD3: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 765.44,
    biweeklyGov: 574.08,
    biweeklyEmp: 191.36,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  DH1: {
    name: 'QualChoice',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 427.67,
    biweeklyGov: 298.08,
    biweeklyEmp: 129.59,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  DH2: {
    name: 'QualChoice',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1115.52,
    biweeklyGov: 714.23,
    biweeklyEmp: 401.29,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  DH3: {
    name: 'QualChoice',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 830.79,
    biweeklyGov: 623.09,
    biweeklyEmp: 207.7,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  DH4: {
    name: 'QualChoice',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 333.83,
    biweeklyGov: 250.37,
    biweeklyEmp: 83.46,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  DH5: {
    name: 'QualChoice',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 870.78,
    biweeklyGov: 653.09,
    biweeklyEmp: 217.69,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  DH6: {
    name: 'QualChoice',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 648.51,
    biweeklyGov: 486.38,
    biweeklyEmp: 162.13,
    link: 'https://www.qualchoice.com/',
    logo: '',
  },
  _2X1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 632.49,
    biweeklyGov: 298.08,
    biweeklyEmp: 334.41,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _2X2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1484.85,
    biweeklyGov: 714.23,
    biweeklyEmp: 770.62,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _2X3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1455.76,
    biweeklyGov: 650.0,
    biweeklyEmp: 805.76,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  B31: {
    name: 'Anthem Blue Cross Select HMO',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 377.87,
    biweeklyGov: 283.4,
    biweeklyEmp: 94.47,
    link: 'https://www.anthem.com/federal/ca',
    logo: '',
  },
  B32: {
    name: 'Anthem Blue Cross Select HMO',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 899.72,
    biweeklyGov: 674.79,
    biweeklyEmp: 224.93,
    link: 'https://www.anthem.com/federal/ca',
    logo: '',
  },
  B33: {
    name: 'Anthem Blue Cross Select HMO',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 816.58,
    biweeklyGov: 612.44,
    biweeklyEmp: 204.14,
    link: 'https://www.anthem.com/federal/ca',
    logo: '',
  },
  LB1: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 928.54,
    biweeklyGov: 298.08,
    biweeklyEmp: 630.46,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  LB2: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 2228.5,
    biweeklyGov: 714.23,
    biweeklyEmp: 1514.27,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  LB3: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 2042.8,
    biweeklyGov: 650.0,
    biweeklyEmp: 1392.8,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P61: {
    name: 'Health Net of California ',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 264.62,
    biweeklyGov: 198.47,
    biweeklyEmp: 66.15,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P62: {
    name: 'Health Net of California ',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 635.09,
    biweeklyGov: 476.32,
    biweeklyEmp: 158.77,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P63: {
    name: 'Health Net of California ',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 582.15,
    biweeklyGov: 436.61,
    biweeklyEmp: 145.54,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P64: {
    name: 'Health Net of California ',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 426.17,
    biweeklyGov: 298.08,
    biweeklyEmp: 128.09,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P65: {
    name: 'Health Net of California ',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1022.81,
    biweeklyGov: 714.23,
    biweeklyEmp: 308.58,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  P66: {
    name: 'Health Net of California ',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 937.58,
    biweeklyGov: 650.0,
    biweeklyEmp: 287.58,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  LP1: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 686.33,
    biweeklyGov: 298.08,
    biweeklyEmp: 388.25,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  LP2: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1647.17,
    biweeklyGov: 714.23,
    biweeklyEmp: 932.94,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  LP3: {
    name: 'Health Net of California ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1509.9,
    biweeklyGov: 650.0,
    biweeklyEmp: 859.9,
    link: 'http://www.healthnet.com/fehb',
    logo: '',
  },
  NZ4: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 344.99,
    biweeklyGov: 258.74,
    biweeklyEmp: 86.25,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NZ5: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 797.36,
    biweeklyGov: 598.02,
    biweeklyEmp: 199.34,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NZ6: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 797.36,
    biweeklyGov: 598.02,
    biweeklyEmp: 199.34,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NZ1: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 456.44,
    biweeklyGov: 298.08,
    biweeklyEmp: 158.36,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NZ2: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1054.93,
    biweeklyGov: 714.23,
    biweeklyEmp: 340.7,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NZ3: {
    name: 'Kaiser Permanente - Fresno California',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1054.93,
    biweeklyGov: 650.0,
    biweeklyEmp: 404.93,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  KC1: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 318.55,
    biweeklyGov: 238.91,
    biweeklyEmp: 79.64,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  KC2: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 745.41,
    biweeklyGov: 559.06,
    biweeklyEmp: 186.35,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  KC3: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 745.41,
    biweeklyGov: 559.06,
    biweeklyEmp: 186.35,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _591: {
    name: 'Kaiser Permanente - Northern California',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 492.79,
    biweeklyGov: 298.08,
    biweeklyEmp: 194.71,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _592: {
    name: 'Kaiser Permanente - Northern California',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1176.34,
    biweeklyGov: 714.23,
    biweeklyEmp: 462.11,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _593: {
    name: 'Kaiser Permanente - Northern California',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1176.34,
    biweeklyGov: 650.0,
    biweeklyEmp: 526.34,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _594: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 406.48,
    biweeklyGov: 298.08,
    biweeklyEmp: 108.4,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _595: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 951.17,
    biweeklyGov: 713.38,
    biweeklyEmp: 237.79,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _596: {
    name: 'Kaiser Permanente - Northern California',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 951.17,
    biweeklyGov: 650.0,
    biweeklyEmp: 301.17,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  FL1: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 190.46,
    biweeklyGov: 142.85,
    biweeklyEmp: 47.61,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  FL2: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 533.26,
    biweeklyGov: 399.95,
    biweeklyEmp: 133.31,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  FL3: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 438.04,
    biweeklyGov: 328.53,
    biweeklyEmp: 109.51,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _624: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 287.46,
    biweeklyGov: 215.6,
    biweeklyEmp: 71.86,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _625: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 664.34,
    biweeklyGov: 498.26,
    biweeklyEmp: 166.08,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _626: {
    name: 'Kaiser Permanente - Southern California',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 664.34,
    biweeklyGov: 498.26,
    biweeklyEmp: 166.08,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _621: {
    name: 'Kaiser Permanente - Southern California',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 426.64,
    biweeklyGov: 298.08,
    biweeklyEmp: 128.56,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _622: {
    name: 'Kaiser Permanente - Southern California',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 986.07,
    biweeklyGov: 714.23,
    biweeklyEmp: 271.84,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _623: {
    name: 'Kaiser Permanente - Southern California',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 986.07,
    biweeklyGov: 650.0,
    biweeklyEmp: 336.07,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  YJ4: {
    name: 'Sharp Health Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 327.1,
    biweeklyGov: 245.33,
    biweeklyEmp: 81.77,
    link: 'https://www.sharphealthplan.com/',
    logo: '',
  },
  YJ5: {
    name: 'Sharp Health Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 785.05,
    biweeklyGov: 588.79,
    biweeklyEmp: 196.26,
    link: 'https://www.sharphealthplan.com/',
    logo: '',
  },
  YJ6: {
    name: 'Sharp Health Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 719.63,
    biweeklyGov: 539.72,
    biweeklyEmp: 179.91,
    link: 'https://www.sharphealthplan.com/',
    logo: '',
  },
  W51: {
    name: 'Western Health Advantage',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 404.37,
    biweeklyGov: 298.08,
    biweeklyEmp: 106.29,
    link: 'https://www.westernhealth.com/',
    logo: '',
  },
  W52: {
    name: 'Western Health Advantage',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 970.5,
    biweeklyGov: 714.23,
    biweeklyEmp: 256.27,
    link: 'https://www.westernhealth.com/',
    logo: '',
  },
  W53: {
    name: 'Western Health Advantage',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 970.5,
    biweeklyGov: 650.0,
    biweeklyEmp: 320.5,
    link: 'https://www.westernhealth.com/',
    logo: '',
  },
  _654: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 371.62,
    biweeklyGov: 278.72,
    biweeklyEmp: 92.9,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _655: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 839.86,
    biweeklyGov: 629.9,
    biweeklyEmp: 209.96,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _656: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 839.86,
    biweeklyGov: 629.9,
    biweeklyEmp: 209.96,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _651: {
    name: 'Kaiser Permanente - Colorado',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 420.43,
    biweeklyGov: 298.08,
    biweeklyEmp: 122.35,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _652: {
    name: 'Kaiser Permanente - Colorado',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 950.15,
    biweeklyGov: 712.61,
    biweeklyEmp: 237.54,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _653: {
    name: 'Kaiser Permanente - Colorado',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 950.15,
    biweeklyGov: 650.0,
    biweeklyEmp: 300.15,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  N41: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 222.35,
    biweeklyGov: 166.76,
    biweeklyEmp: 55.59,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  N42: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 546.99,
    biweeklyGov: 410.24,
    biweeklyEmp: 136.75,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  N43: {
    name: 'Kaiser Permanente - Colorado',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 502.51,
    biweeklyGov: 376.88,
    biweeklyEmp: 125.63,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  EP4: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 675.85,
    biweeklyGov: 298.08,
    biweeklyEmp: 377.77,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  EP5: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 1547.64,
    biweeklyGov: 714.23,
    biweeklyEmp: 833.41,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  EP6: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 1517.27,
    biweeklyGov: 650.0,
    biweeklyEmp: 867.27,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  EP1: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 634.64,
    biweeklyGov: 298.08,
    biweeklyEmp: 336.56,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  EP2: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1447.31,
    biweeklyGov: 714.23,
    biweeklyEmp: 733.08,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  EP3: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1432.97,
    biweeklyGov: 650.0,
    biweeklyEmp: 782.97,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P34: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 828.39,
    biweeklyGov: 298.08,
    biweeklyEmp: 530.31,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P35: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 1922.7,
    biweeklyGov: 714.23,
    biweeklyEmp: 1208.47,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P36: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 1903.64,
    biweeklyGov: 650.0,
    biweeklyEmp: 1253.64,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P31: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 842.99,
    biweeklyGov: 298.08,
    biweeklyEmp: 544.91,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P32: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 2043.84,
    biweeklyGov: 714.23,
    biweeklyEmp: 1329.61,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P33: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 2023.61,
    biweeklyGov: 650.0,
    biweeklyEmp: 1373.61,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 679.23,
    biweeklyGov: 298.08,
    biweeklyEmp: 381.15,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1527.04,
    biweeklyGov: 714.23,
    biweeklyEmp: 812.81,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1511.9,
    biweeklyGov: 650.0,
    biweeklyEmp: 861.9,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN4: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 398.7,
    biweeklyGov: 298.08,
    biweeklyEmp: 100.62,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN5: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 912.43,
    biweeklyGov: 684.32,
    biweeklyEmp: 228.11,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JN6: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 837.87,
    biweeklyGov: 628.4,
    biweeklyEmp: 209.47,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  QQ4: {
    name: 'Aetna Saver (Open Access) ',
    option: 'Saver',
    type: 'Self',
    biweeklyTotal: 270.73,
    biweeklyGov: 203.05,
    biweeklyEmp: 67.68,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  QQ5: {
    name: 'Aetna Saver (Open Access) ',
    option: 'Saver',
    type: 'Self & Family',
    biweeklyTotal: 619.57,
    biweeklyGov: 464.68,
    biweeklyEmp: 154.89,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  QQ6: {
    name: 'Aetna Saver (Open Access) ',
    option: 'Saver',
    type: 'Self Plus One',
    biweeklyTotal: 568.94,
    biweeklyGov: 426.71,
    biweeklyEmp: 142.23,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _2G4: {
    name: 'CareFirst BlueChoice',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 540.53,
    biweeklyGov: 298.08,
    biweeklyEmp: 242.45,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  _2G5: {
    name: 'CareFirst BlueChoice',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1284.29,
    biweeklyGov: 714.23,
    biweeklyEmp: 570.06,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  _2G6: {
    name: 'CareFirst BlueChoice',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1081.06,
    biweeklyGov: 650.0,
    biweeklyEmp: 431.06,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B61: {
    name: 'CareFirst BlueChoice',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 345.37,
    biweeklyGov: 259.03,
    biweeklyEmp: 86.34,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B62: {
    name: 'CareFirst BlueChoice',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 820.59,
    biweeklyGov: 615.44,
    biweeklyEmp: 205.15,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B63: {
    name: 'CareFirst BlueChoice',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 690.74,
    biweeklyGov: 518.06,
    biweeklyEmp: 172.68,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B64: {
    name: 'CareFirst BlueChoice',
    option: 'Blue Value Plus',
    type: 'Self',
    biweeklyTotal: 357.71,
    biweeklyGov: 268.28,
    biweeklyEmp: 89.43,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B65: {
    name: 'CareFirst BlueChoice',
    option: 'Blue Value Plus',
    type: 'Self & Family',
    biweeklyTotal: 849.9,
    biweeklyGov: 637.43,
    biweeklyEmp: 212.47,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  B66: {
    name: 'CareFirst BlueChoice',
    option: 'Blue Value Plus',
    type: 'Self Plus One',
    biweeklyTotal: 715.42,
    biweeklyGov: 536.57,
    biweeklyEmp: 178.85,
    link: 'https://www.carefirst.com/',
    logo: '',
  },
  T71: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 207.37,
    biweeklyGov: 155.53,
    biweeklyEmp: 51.84,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  T72: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 583.43,
    biweeklyGov: 437.57,
    biweeklyEmp: 145.86,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  T73: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 495.41,
    biweeklyGov: 371.56,
    biweeklyEmp: 123.85,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E34: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 355.42,
    biweeklyGov: 266.57,
    biweeklyEmp: 88.85,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E35: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 817.48,
    biweeklyGov: 613.11,
    biweeklyEmp: 204.37,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E36: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 817.48,
    biweeklyGov: 613.11,
    biweeklyEmp: 204.37,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E31: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 444.13,
    biweeklyGov: 298.08,
    biweeklyEmp: 146.05,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E32: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1021.51,
    biweeklyGov: 714.23,
    biweeklyEmp: 307.28,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  E33: {
    name: 'Kaiser Permanente - Mid-Atlantic States',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1021.51,
    biweeklyGov: 650.0,
    biweeklyEmp: 371.51,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  JP1: {
    name: 'M.D. IPA ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 535.05,
    biweeklyGov: 298.08,
    biweeklyEmp: 236.97,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  JP2: {
    name: 'M.D. IPA ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1500.31,
    biweeklyGov: 714.23,
    biweeklyEmp: 786.08,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  JP3: {
    name: 'M.D. IPA ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1044.97,
    biweeklyGov: 650.0,
    biweeklyEmp: 394.97,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  V41: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 324.07,
    biweeklyGov: 243.05,
    biweeklyEmp: 81.02,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  V42: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 741.8,
    biweeklyGov: 556.35,
    biweeklyEmp: 185.45,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  V43: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 696.76,
    biweeklyGov: 522.57,
    biweeklyEmp: 174.19,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LR1: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 522.64,
    biweeklyGov: 298.08,
    biweeklyEmp: 224.56,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LR2: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1238.64,
    biweeklyGov: 714.23,
    biweeklyEmp: 524.41,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  LR3: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1123.66,
    biweeklyGov: 650.0,
    biweeklyEmp: 473.66,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  L91: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 383.25,
    biweeklyGov: 287.44,
    biweeklyEmp: 95.81,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  L92: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 919.4,
    biweeklyGov: 689.55,
    biweeklyEmp: 229.85,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  L93: {
    name: 'UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 814.03,
    biweeklyGov: 610.52,
    biweeklyEmp: 203.51,
    link: 'http://www.uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  WZ1: {
    name: 'AvMed',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 428.04,
    biweeklyGov: 298.08,
    biweeklyEmp: 129.96,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  WZ2: {
    name: 'AvMed',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 1000.57,
    biweeklyGov: 714.23,
    biweeklyEmp: 286.34,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  WZ3: {
    name: 'AvMed',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 866.75,
    biweeklyGov: 650.0,
    biweeklyEmp: 216.75,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  ML4: {
    name: 'AvMed',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 540.86,
    biweeklyGov: 298.08,
    biweeklyEmp: 242.78,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  ML5: {
    name: 'AvMed',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1316.89,
    biweeklyGov: 714.23,
    biweeklyEmp: 602.66,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  ML6: {
    name: 'AvMed',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1135.48,
    biweeklyGov: 650.0,
    biweeklyEmp: 485.48,
    link: 'https://www.avmed.org/',
    logo: '',
  },
  EA1: {
    name: 'Capital Health Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 419.94,
    biweeklyGov: 298.08,
    biweeklyEmp: 121.86,
    link: 'https://capitalhealth.com/',
    logo: '',
  },
  EA2: {
    name: 'Capital Health Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1001.78,
    biweeklyGov: 714.23,
    biweeklyEmp: 287.55,
    link: 'https://capitalhealth.com/',
    logo: '',
  },
  EA3: {
    name: 'Capital Health Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 918.34,
    biweeklyGov: 650.0,
    biweeklyEmp: 268.34,
    link: 'https://capitalhealth.com/',
    logo: '',
  },
  _2U1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 858.61,
    biweeklyGov: 298.08,
    biweeklyEmp: 560.53,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _2U2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1977.77,
    biweeklyGov: 714.23,
    biweeklyEmp: 1263.54,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _2U3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1958.18,
    biweeklyGov: 650.0,
    biweeklyEmp: 1308.18,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  F81: {
    name: 'Kaiser Permanente - Georgia',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 449.97,
    biweeklyGov: 298.08,
    biweeklyEmp: 151.89,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  F82: {
    name: 'Kaiser Permanente - Georgia',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1016.93,
    biweeklyGov: 714.23,
    biweeklyEmp: 302.7,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  F83: {
    name: 'Kaiser Permanente - Georgia',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1016.93,
    biweeklyGov: 650.0,
    biweeklyEmp: 366.93,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  F84: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 346.35,
    biweeklyGov: 259.76,
    biweeklyEmp: 86.59,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  F85: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 782.75,
    biweeklyGov: 587.06,
    biweeklyEmp: 195.69,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  F86: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 782.75,
    biweeklyGov: 587.06,
    biweeklyEmp: 195.69,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  LA1: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 242.2,
    biweeklyGov: 181.65,
    biweeklyEmp: 60.55,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  LA2: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 628.79,
    biweeklyGov: 471.59,
    biweeklyEmp: 157.2,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  LA3: {
    name: 'Kaiser Permanente - Georgia',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 547.35,
    biweeklyGov: 410.51,
    biweeklyEmp: 136.84,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  B44: {
    name: "Calvo's SelectCare",
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 196.28,
    biweeklyGov: 147.21,
    biweeklyEmp: 49.07,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  B45: {
    name: "Calvo's SelectCare",
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 570.36,
    biweeklyGov: 427.77,
    biweeklyEmp: 142.59,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  B46: {
    name: "Calvo's SelectCare",
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 386.96,
    biweeklyGov: 290.22,
    biweeklyEmp: 96.74,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  B41: {
    name: "Calvo's SelectCare",
    option: 'High',
    type: 'Self',
    biweeklyTotal: 269.73,
    biweeklyGov: 202.3,
    biweeklyEmp: 67.43,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  B42: {
    name: "Calvo's SelectCare",
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 714.44,
    biweeklyGov: 535.83,
    biweeklyEmp: 178.61,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  B43: {
    name: "Calvo's SelectCare",
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 526.4,
    biweeklyGov: 394.8,
    biweeklyEmp: 131.6,
    link: 'https://www.calvos.net/FEHB.aspx',
    logo: '',
  },
  KX1: {
    name: 'TakeCare',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 78.88,
    biweeklyGov: 59.16,
    biweeklyEmp: 19.72,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  KX2: {
    name: 'TakeCare',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 211.48,
    biweeklyGov: 158.61,
    biweeklyEmp: 52.87,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  KX3: {
    name: 'TakeCare',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 190.43,
    biweeklyGov: 142.82,
    biweeklyEmp: 47.61,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK4: {
    name: 'TakeCare',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 196.96,
    biweeklyGov: 147.72,
    biweeklyEmp: 49.24,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK5: {
    name: 'TakeCare',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 650.05,
    biweeklyGov: 487.54,
    biweeklyEmp: 162.51,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK6: {
    name: 'TakeCare',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 394.64,
    biweeklyGov: 295.98,
    biweeklyEmp: 98.66,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK1: {
    name: 'TakeCare',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 268.32,
    biweeklyGov: 201.24,
    biweeklyEmp: 67.08,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK2: {
    name: 'TakeCare',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 771.43,
    biweeklyGov: 578.57,
    biweeklyEmp: 192.86,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  JK3: {
    name: 'TakeCare',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 536.45,
    biweeklyGov: 402.34,
    biweeklyEmp: 134.11,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  _871: {
    name: 'HMSA Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 342.9,
    biweeklyGov: 257.18,
    biweeklyEmp: 85.72,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _872: {
    name: 'HMSA Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 770.85,
    biweeklyGov: 578.14,
    biweeklyEmp: 192.71,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _873: {
    name: 'HMSA Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 751.34,
    biweeklyGov: 563.51,
    biweeklyEmp: 187.83,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _874: {
    name: 'HMSA Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 235.33,
    biweeklyGov: 176.5,
    biweeklyEmp: 58.83,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _875: {
    name: 'HMSA Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 529.0,
    biweeklyGov: 396.75,
    biweeklyEmp: 132.25,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _876: {
    name: 'HMSA Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 515.58,
    biweeklyGov: 386.69,
    biweeklyEmp: 128.89,
    link: 'https://hmsa.com/',
    logo: '',
  },
  _631: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 348.76,
    biweeklyGov: 261.57,
    biweeklyEmp: 87.19,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _632: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 777.74,
    biweeklyGov: 583.31,
    biweeklyEmp: 194.43,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _633: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 777.74,
    biweeklyGov: 583.31,
    biweeklyEmp: 194.43,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _634: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 240.03,
    biweeklyGov: 180.02,
    biweeklyEmp: 60.01,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _635: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 535.28,
    biweeklyGov: 401.46,
    biweeklyEmp: 133.82,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _636: {
    name: 'Kaiser Permanente - Hawaii',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 535.28,
    biweeklyGov: 401.46,
    biweeklyEmp: 133.82,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H41: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 527.64,
    biweeklyGov: 298.08,
    biweeklyEmp: 229.56,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  H42: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1202.72,
    biweeklyGov: 714.23,
    biweeklyEmp: 488.49,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  H43: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1191.07,
    biweeklyGov: 650.0,
    biweeklyEmp: 541.07,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  H44: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 648.44,
    biweeklyGov: 298.08,
    biweeklyEmp: 350.36,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  H45: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 1488.13,
    biweeklyGov: 714.23,
    biweeklyEmp: 773.9,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  H46: {
    name: 'Aetna HealthFund CDHP and Aetna Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 1458.95,
    biweeklyGov: 650.0,
    biweeklyEmp: 808.95,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  _9K1: {
    name: 'Altius Health Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 633.2,
    biweeklyGov: 298.08,
    biweeklyEmp: 335.12,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _9K2: {
    name: 'Altius Health Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1400.34,
    biweeklyGov: 714.23,
    biweeklyEmp: 686.11,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _9K3: {
    name: 'Altius Health Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1386.5,
    biweeklyGov: 650.0,
    biweeklyEmp: 736.5,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _9K4: {
    name: 'Altius Health Plan',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 442.74,
    biweeklyGov: 298.08,
    biweeklyEmp: 144.66,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _9K5: {
    name: 'Altius Health Plan',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 925.31,
    biweeklyGov: 693.98,
    biweeklyEmp: 231.33,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _9K6: {
    name: 'Altius Health Plan',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 907.12,
    biweeklyGov: 650.0,
    biweeklyEmp: 257.12,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  DK4: {
    name: 'Altius Health Plan ',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 512.14,
    biweeklyGov: 298.08,
    biweeklyEmp: 214.06,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  DK5: {
    name: 'Altius Health Plan ',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1130.99,
    biweeklyGov: 714.23,
    biweeklyEmp: 416.76,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  DK6: {
    name: 'Altius Health Plan ',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1119.79,
    biweeklyGov: 650.0,
    biweeklyEmp: 469.79,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: '',
  },
  _544: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 385.04,
    biweeklyGov: 288.78,
    biweeklyEmp: 96.26,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _545: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 885.61,
    biweeklyGov: 664.21,
    biweeklyEmp: 221.4,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _546: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 885.61,
    biweeklyGov: 650.0,
    biweeklyEmp: 235.61,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _541: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 506.81,
    biweeklyGov: 298.08,
    biweeklyEmp: 208.73,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _542: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1114.99,
    biweeklyGov: 714.23,
    biweeklyEmp: 400.76,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _543: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1114.99,
    biweeklyGov: 650.0,
    biweeklyEmp: 464.99,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PT4: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 190.27,
    biweeklyGov: 142.7,
    biweeklyEmp: 47.57,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PT5: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 532.76,
    biweeklyGov: 399.57,
    biweeklyEmp: 133.19,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PT6: {
    name: 'Kaiser Permanente - Washington Core',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 460.88,
    biweeklyGov: 345.66,
    biweeklyEmp: 115.22,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  K84: {
    name: 'Health Alliance HMO',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 512.46,
    biweeklyGov: 298.08,
    biweeklyEmp: 214.38,
    link: 'https://www.healthalliance.org/',
    logo: '',
  },
  K85: {
    name: 'Health Alliance HMO',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1201.55,
    biweeklyGov: 714.23,
    biweeklyEmp: 487.32,
    link: 'https://www.healthalliance.org/',
    logo: '',
  },
  K86: {
    name: 'Health Alliance HMO',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1097.95,
    biweeklyGov: 650.0,
    biweeklyEmp: 447.95,
    link: 'https://www.healthalliance.org/',
    logo: '',
  },
  V34: {
    name: 'HealthPartners',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 291.73,
    biweeklyGov: 218.8,
    biweeklyEmp: 72.93,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  V35: {
    name: 'HealthPartners',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 710.66,
    biweeklyGov: 533.0,
    biweeklyEmp: 177.66,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  V36: {
    name: 'HealthPartners',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 644.73,
    biweeklyGov: 483.55,
    biweeklyEmp: 161.18,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  V31: {
    name: 'HealthPartners',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 419.99,
    biweeklyGov: 298.08,
    biweeklyEmp: 121.91,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  V32: {
    name: 'HealthPartners',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1023.1,
    biweeklyGov: 714.23,
    biweeklyEmp: 308.87,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  V33: {
    name: 'HealthPartners',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 928.18,
    biweeklyGov: 650.0,
    biweeklyEmp: 278.18,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  LX1: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 517.89,
    biweeklyGov: 298.08,
    biweeklyEmp: 219.81,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  LX2: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1263.65,
    biweeklyGov: 714.23,
    biweeklyEmp: 549.42,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  LX3: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1191.16,
    biweeklyGov: 650.0,
    biweeklyEmp: 541.16,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  K51: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 483.82,
    biweeklyGov: 298.08,
    biweeklyEmp: 185.74,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  K52: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1180.54,
    biweeklyGov: 714.23,
    biweeklyEmp: 466.31,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  K53: {
    name: 'Blue Care Network of Michigan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1112.79,
    biweeklyGov: 650.0,
    biweeklyEmp: 462.79,
    link: 'https://www.bcbsm.com/',
    logo: '',
  },
  _521: {
    name: 'Health Alliance Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 611.09,
    biweeklyGov: 298.08,
    biweeklyEmp: 313.01,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  _522: {
    name: 'Health Alliance Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1491.07,
    biweeklyGov: 714.23,
    biweeklyEmp: 776.84,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  _523: {
    name: 'Health Alliance Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1405.52,
    biweeklyGov: 650.0,
    biweeklyEmp: 755.52,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  GY4: {
    name: 'Health Alliance Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 365.07,
    biweeklyGov: 273.8,
    biweeklyEmp: 91.27,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  GY5: {
    name: 'Health Alliance Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 890.77,
    biweeklyGov: 668.08,
    biweeklyEmp: 222.69,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  GY6: {
    name: 'Health Alliance Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 839.66,
    biweeklyGov: 629.75,
    biweeklyEmp: 209.91,
    link: 'http://www.hap.org/fehb',
    logo: '',
  },
  LE1: {
    name: 'Priority Health',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 689.37,
    biweeklyGov: 298.08,
    biweeklyEmp: 391.29,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  LE2: {
    name: 'Priority Health',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1620.04,
    biweeklyGov: 714.23,
    biweeklyEmp: 905.81,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  LE3: {
    name: 'Priority Health',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1516.63,
    biweeklyGov: 650.0,
    biweeklyEmp: 866.63,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  LE4: {
    name: 'Priority Health',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 353.58,
    biweeklyGov: 265.19,
    biweeklyEmp: 88.39,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  LE5: {
    name: 'Priority Health',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 830.9,
    biweeklyGov: 623.18,
    biweeklyEmp: 207.72,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  LE6: {
    name: 'Priority Health',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 777.87,
    biweeklyGov: 583.4,
    biweeklyEmp: 194.47,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  Y41: {
    name: 'Priority Health',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 242.24,
    biweeklyGov: 181.68,
    biweeklyEmp: 60.56,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  Y42: {
    name: 'Priority Health',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 569.25,
    biweeklyGov: 426.94,
    biweeklyEmp: 142.31,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  Y43: {
    name: 'Priority Health',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 532.92,
    biweeklyGov: 399.69,
    biweeklyEmp: 133.23,
    link: 'https://www.priorityhealth.com/fehb/plan-details',
    logo: '',
  },
  NM1: {
    name: 'Health Plan of Nevada, Inc.',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 426.4,
    biweeklyGov: 298.08,
    biweeklyEmp: 128.32,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  NM2: {
    name: 'Health Plan of Nevada, Inc.',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1010.55,
    biweeklyGov: 714.23,
    biweeklyEmp: 296.32,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  NM3: {
    name: 'Health Plan of Nevada, Inc.',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 810.17,
    biweeklyGov: 607.63,
    biweeklyEmp: 202.54,
    link: 'https://uhcfeds.com',
    logo: '',
  },
  JR1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 1065.63,
    biweeklyGov: 298.08,
    biweeklyEmp: 767.55,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JR2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 2461.44,
    biweeklyGov: 714.23,
    biweeklyEmp: 1747.21,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JR3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 2437.06,
    biweeklyGov: 650.0,
    biweeklyEmp: 1787.06,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JR4: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 862.91,
    biweeklyGov: 298.08,
    biweeklyEmp: 564.83,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JR5: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 1999.86,
    biweeklyGov: 714.23,
    biweeklyEmp: 1285.63,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JR6: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 1980.05,
    biweeklyGov: 650.0,
    biweeklyEmp: 1330.05,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  P21: {
    name: 'Presbyterian Health Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 502.09,
    biweeklyGov: 298.08,
    biweeklyEmp: 204.01,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  P22: {
    name: 'Presbyterian Health Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1179.92,
    biweeklyGov: 714.23,
    biweeklyEmp: 465.69,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  P23: {
    name: 'Presbyterian Health Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1139.81,
    biweeklyGov: 650.0,
    biweeklyEmp: 489.81,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS4: {
    name: 'Presbyterian Health Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 420.79,
    biweeklyGov: 298.08,
    biweeklyEmp: 122.71,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS5: {
    name: 'Presbyterian Health Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 988.87,
    biweeklyGov: 714.23,
    biweeklyEmp: 274.64,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS6: {
    name: 'Presbyterian Health Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 955.25,
    biweeklyGov: 650.0,
    biweeklyEmp: 305.25,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS1: {
    name: 'Presbyterian Health Plan',
    option: 'Wellness',
    type: 'Self',
    biweeklyTotal: 374.19,
    biweeklyGov: 280.64,
    biweeklyEmp: 93.55,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS2: {
    name: 'Presbyterian Health Plan',
    option: 'Wellness',
    type: 'Self & Family',
    biweeklyTotal: 879.34,
    biweeklyGov: 659.51,
    biweeklyEmp: 219.83,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  PS3: {
    name: 'Presbyterian Health Plan',
    option: 'Wellness',
    type: 'Self Plus One',
    biweeklyTotal: 849.44,
    biweeklyGov: 637.08,
    biweeklyEmp: 212.36,
    link: 'https://onbaseext.phs.org/',
    logo: '',
  },
  JC1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 887.23,
    biweeklyGov: 298.08,
    biweeklyEmp: 589.15,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JC2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 2192.36,
    biweeklyGov: 714.23,
    biweeklyEmp: 1478.13,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JC3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 2170.66,
    biweeklyGov: 650.0,
    biweeklyEmp: 1520.66,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JC4: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 780.37,
    biweeklyGov: 298.08,
    biweeklyEmp: 482.29,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JC5: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 1903.49,
    biweeklyGov: 714.23,
    biweeklyEmp: 1189.26,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JC6: {
    name: 'Aetna Open Access',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 1884.66,
    biweeklyGov: 650.0,
    biweeklyEmp: 1234.66,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  C54: {
    name: 'Independent Health',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 396.86,
    biweeklyGov: 297.65,
    biweeklyEmp: 99.21,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  C55: {
    name: 'Independent Health',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1071.52,
    biweeklyGov: 714.23,
    biweeklyEmp: 357.29,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  C56: {
    name: 'Independent Health',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1011.99,
    biweeklyGov: 650.0,
    biweeklyEmp: 361.99,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA1: {
    name: 'Independent Health ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 440.58,
    biweeklyGov: 298.08,
    biweeklyEmp: 142.5,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA2: {
    name: 'Independent Health ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1189.56,
    biweeklyGov: 714.23,
    biweeklyEmp: 475.33,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA3: {
    name: 'Independent Health ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1123.47,
    biweeklyGov: 650.0,
    biweeklyEmp: 473.47,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA4: {
    name: 'Independent Health ',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 338.12,
    biweeklyGov: 253.59,
    biweeklyEmp: 84.53,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA5: {
    name: 'Independent Health ',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 880.13,
    biweeklyGov: 660.1,
    biweeklyEmp: 220.03,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  QA6: {
    name: 'Independent Health ',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 836.37,
    biweeklyGov: 627.28,
    biweeklyEmp: 209.09,
    link: 'https://www.independenthealth.com/IndividualsFamilies/FindAHealthPlan#!/PlanDetails/large/off/FEHBPlanOfferings',
    logo: '',
  },
  YF1: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 222.85,
    biweeklyGov: 167.14,
    biweeklyEmp: 55.71,
    link: 'https://www.MedMutual.com/feds',
    logo: '',
  },
  YF2: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 534.86,
    biweeklyGov: 401.15,
    biweeklyEmp: 133.71,
    link: 'https://www.MedMutual.com/feds',
    logo: '',
  },
  YF3: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 490.28,
    biweeklyGov: 367.71,
    biweeklyEmp: 122.57,
    link: 'https://www.MedMutual.com/feds',
    logo: '',
  },
  _644: {
    name: 'Medical Mutual of Ohio',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 613.18,
    biweeklyGov: 298.08,
    biweeklyEmp: 315.1,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  _645: {
    name: 'Medical Mutual of Ohio',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1471.63,
    biweeklyGov: 714.23,
    biweeklyEmp: 757.4,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  _646: {
    name: 'Medical Mutual of Ohio',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1348.98,
    biweeklyGov: 650.0,
    biweeklyEmp: 698.98,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  UX1: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 214.48,
    biweeklyGov: 160.86,
    biweeklyEmp: 53.62,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  UX2: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 514.74,
    biweeklyGov: 386.06,
    biweeklyEmp: 128.68,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  UX3: {
    name: 'Medical Mutual of Ohio',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 471.85,
    biweeklyGov: 353.89,
    biweeklyEmp: 117.96,
    link: 'https://www.MedMutual.com/Feds',
    logo: '',
  },
  _574: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 385.87,
    biweeklyGov: 289.4,
    biweeklyEmp: 96.47,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _575: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 886.45,
    biweeklyGov: 664.84,
    biweeklyEmp: 221.61,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _576: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 886.45,
    biweeklyGov: 650.0,
    biweeklyEmp: 236.45,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _571: {
    name: 'Kaiser Permanente - Northwest',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 430.58,
    biweeklyGov: 298.08,
    biweeklyEmp: 132.5,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _572: {
    name: 'Kaiser Permanente - Northwest',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 972.55,
    biweeklyGov: 714.23,
    biweeklyEmp: 258.32,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _573: {
    name: 'Kaiser Permanente - Northwest',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 972.55,
    biweeklyGov: 650.0,
    biweeklyEmp: 322.55,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  AM1: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 212.92,
    biweeklyGov: 159.69,
    biweeklyEmp: 53.23,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  AM2: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 528.03,
    biweeklyGov: 396.02,
    biweeklyEmp: 132.01,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  AM3: {
    name: 'Kaiser Permanente - Northwest',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 457.75,
    biweeklyGov: 343.31,
    biweeklyEmp: 114.44,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  YE1: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 783.15,
    biweeklyGov: 298.08,
    biweeklyEmp: 485.07,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  YE2: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1966.5,
    biweeklyGov: 714.23,
    biweeklyEmp: 1252.27,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  YE3: {
    name: 'Aetna Open Access',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1947.05,
    biweeklyGov: 650.0,
    biweeklyEmp: 1297.05,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GG4: {
    name: 'Geisinger Health Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 510.97,
    biweeklyGov: 298.08,
    biweeklyEmp: 212.89,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  GG5: {
    name: 'Geisinger Health Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1169.88,
    biweeklyGov: 714.23,
    biweeklyEmp: 455.65,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  GG6: {
    name: 'Geisinger Health Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1104.05,
    biweeklyGov: 650.0,
    biweeklyEmp: 454.05,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  AJ1: {
    name: 'Geisinger Health Plan',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 466.9,
    biweeklyGov: 298.08,
    biweeklyEmp: 168.82,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  AJ2: {
    name: 'Geisinger Health Plan',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 1068.97,
    biweeklyGov: 714.23,
    biweeklyEmp: 354.74,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  AJ3: {
    name: 'Geisinger Health Plan',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 1008.82,
    biweeklyGov: 650.0,
    biweeklyEmp: 358.82,
    link: 'https://TheHealthPlan.com/federal',
    logo: '',
  },
  _8W4: {
    name: 'UPMC Health Plan ',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 329.33,
    biweeklyGov: 247.0,
    biweeklyEmp: 82.33,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  _8W5: {
    name: 'UPMC Health Plan ',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 875.97,
    biweeklyGov: 656.98,
    biweeklyEmp: 218.99,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  _8W6: {
    name: 'UPMC Health Plan ',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 786.71,
    biweeklyGov: 590.03,
    biweeklyEmp: 196.68,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  UW4: {
    name: 'UPMC Health Plan ',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 357.27,
    biweeklyGov: 267.95,
    biweeklyEmp: 89.32,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  UW5: {
    name: 'UPMC Health Plan ',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 979.56,
    biweeklyGov: 714.23,
    biweeklyEmp: 265.33,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  UW6: {
    name: 'UPMC Health Plan ',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 871.63,
    biweeklyGov: 650.0,
    biweeklyEmp: 221.63,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  _891: {
    name: 'Triple-S Salud Inc. Puerto Rico',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 215.36,
    biweeklyGov: 161.52,
    biweeklyEmp: 53.84,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  _892: {
    name: 'Triple-S Salud Inc. Puerto Rico',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 493.19,
    biweeklyGov: 369.89,
    biweeklyEmp: 123.3,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  _893: {
    name: 'Triple-S Salud Inc. Puerto Rico',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 483.57,
    biweeklyGov: 362.68,
    biweeklyEmp: 120.89,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  A81: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 250.78,
    biweeklyGov: 188.09,
    biweeklyEmp: 62.69,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  A82: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 589.31,
    biweeklyGov: 441.98,
    biweeklyEmp: 147.33,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  A83: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 556.7,
    biweeklyGov: 417.53,
    biweeklyEmp: 139.17,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  A84: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 429.34,
    biweeklyGov: 298.08,
    biweeklyEmp: 131.26,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  A85: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1008.97,
    biweeklyGov: 714.23,
    biweeklyEmp: 294.74,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  A86: {
    name: 'Baylor Scott & White Health Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 953.15,
    biweeklyGov: 650.0,
    biweeklyEmp: 303.15,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P81: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 266.19,
    biweeklyGov: 199.64,
    biweeklyEmp: 66.55,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P82: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 625.55,
    biweeklyGov: 469.16,
    biweeklyEmp: 156.39,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P83: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 590.94,
    biweeklyGov: 443.21,
    biweeklyEmp: 147.73,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P84: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 489.09,
    biweeklyGov: 298.08,
    biweeklyEmp: 191.01,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P85: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1149.37,
    biweeklyGov: 714.23,
    biweeklyEmp: 435.14,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  P86: {
    name: 'Baylor Scott & White Health Plan ',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1085.78,
    biweeklyGov: 650.0,
    biweeklyEmp: 435.78,
    link: 'http://www.bswhealthplan.com/fehb',
    logo: '',
  },
  SF4: {
    name: 'SelectHealth, Inc.',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 408.84,
    biweeklyGov: 298.08,
    biweeklyEmp: 110.76,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  SF5: {
    name: 'SelectHealth, Inc.',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1022.12,
    biweeklyGov: 714.23,
    biweeklyEmp: 307.89,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  SF6: {
    name: 'SelectHealth, Inc.',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 899.45,
    biweeklyGov: 650.0,
    biweeklyEmp: 249.45,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  WX1: {
    name: 'SelectHealth, Inc.',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 378.01,
    biweeklyGov: 283.51,
    biweeklyEmp: 94.5,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  WX2: {
    name: 'SelectHealth, Inc.',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 945.03,
    biweeklyGov: 708.77,
    biweeklyEmp: 236.26,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  WX3: {
    name: 'SelectHealth, Inc.',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 831.62,
    biweeklyGov: 623.72,
    biweeklyEmp: 207.9,
    link: 'https://selecthealth.org/document-lookup#rich-text-content',
    logo: '',
  },
  _851: {
    name: 'Triple-S Salud Inc. U.S. Virgin Islands',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 300.99,
    biweeklyGov: 225.74,
    biweeklyEmp: 75.25,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  _852: {
    name: 'Triple-S Salud Inc. U.S. Virgin Islands',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 689.27,
    biweeklyGov: 516.95,
    biweeklyEmp: 172.32,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  _853: {
    name: 'Triple-S Salud Inc. U.S. Virgin Islands',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 675.81,
    biweeklyGov: 506.86,
    biweeklyEmp: 168.95,
    link: 'https://salud.grupotriples.com/',
    logo: '',
  },
  F21: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 327.42,
    biweeklyGov: 245.57,
    biweeklyEmp: 81.85,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  F22: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 749.32,
    biweeklyGov: 561.99,
    biweeklyEmp: 187.33,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  F23: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 749.26,
    biweeklyGov: 561.95,
    biweeklyEmp: 187.31,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG4: {
    name: 'Sentara Health Plans',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 323.55,
    biweeklyGov: 242.66,
    biweeklyEmp: 80.89,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG5: {
    name: 'Sentara Health Plans',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 713.69,
    biweeklyGov: 535.27,
    biweeklyEmp: 178.42,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG6: {
    name: 'Sentara Health Plans',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 699.71,
    biweeklyGov: 524.78,
    biweeklyEmp: 174.93,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG1: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 425.81,
    biweeklyGov: 298.08,
    biweeklyEmp: 127.73,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG2: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1028.87,
    biweeklyGov: 714.23,
    biweeklyEmp: 314.64,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  PG3: {
    name: 'Sentara Health Plans',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1028.8,
    biweeklyGov: 650.0,
    biweeklyEmp: 378.8,
    link: 'https://www.sentarahealthplans.com/federal',
    logo: '',
  },
  L11: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 348.24,
    biweeklyGov: 261.18,
    biweeklyEmp: 87.06,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  L12: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 773.1,
    biweeklyGov: 579.83,
    biweeklyEmp: 193.27,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  L13: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 773.1,
    biweeklyGov: 579.83,
    biweeklyEmp: 193.27,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  L14: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 364.89,
    biweeklyGov: 273.67,
    biweeklyEmp: 91.22,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  L15: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 810.04,
    biweeklyGov: 607.53,
    biweeklyEmp: 202.51,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  L16: {
    name: 'Kaiser Permanente Washington Options Federal ',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 810.04,
    biweeklyGov: 607.53,
    biweeklyEmp: 202.51,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  WJ1: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 600.44,
    biweeklyGov: 298.08,
    biweeklyEmp: 302.36,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  WJ2: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1561.24,
    biweeklyGov: 714.23,
    biweeklyEmp: 847.01,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  WJ3: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1321.04,
    biweeklyGov: 650.0,
    biweeklyEmp: 671.04,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  WJ4: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 380.75,
    biweeklyGov: 285.56,
    biweeklyEmp: 95.19,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  WJ5: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 989.98,
    biweeklyGov: 714.23,
    biweeklyEmp: 275.75,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  WJ6: {
    name: 'Group Health Cooperative of South Central Wisconsin',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 837.68,
    biweeklyGov: 628.26,
    biweeklyEmp: 209.42,
    link: 'https://www.ghcscw.com/health-insurance/government-employees',
    logo: '',
  },
  _474: {
    name: 'APWU Health Plan ',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 343.99,
    biweeklyGov: 257.99,
    biweeklyEmp: 86.0,
    link: 'https://www.apwuhp.com/our-plans/consumer-driven-option/benefits-at-a-glance/',
    logo: '',
  },
  _475: {
    name: 'APWU Health Plan ',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 815.61,
    biweeklyGov: 611.71,
    biweeklyEmp: 203.9,
    link: 'https://www.apwuhp.com/our-plans/consumer-driven-option/benefits-at-a-glance/',
    logo: '',
  },
  _476: {
    name: 'APWU Health Plan ',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 747.64,
    biweeklyGov: 560.73,
    biweeklyEmp: 186.91,
    link: 'https://www.apwuhp.com/our-plans/consumer-driven-option/benefits-at-a-glance/',
    logo: '',
  },
  _471: {
    name: 'APWU Health Plan ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 407.83,
    biweeklyGov: 298.08,
    biweeklyEmp: 109.75,
    link: 'https://www.apwuhp.com/our-plans/high-option/benefits-at-a-glance/',
    logo: '',
  },
  _472: {
    name: 'APWU Health Plan ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 978.73,
    biweeklyGov: 714.23,
    biweeklyEmp: 264.5,
    link: 'https://www.apwuhp.com/our-plans/high-option/benefits-at-a-glance/',
    logo: '',
  },
  _473: {
    name: 'APWU Health Plan ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 856.39,
    biweeklyGov: 642.29,
    biweeklyEmp: 214.1,
    link: 'https://www.apwuhp.com/our-plans/high-option/benefits-at-a-glance/',
    logo: '',
  },
  _111: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    option: 'Basic',
    type: 'Self',
    biweeklyTotal: 411.24,
    biweeklyGov: 298.08,
    biweeklyEmp: 113.16,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _112: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    option: 'Basic',
    type: 'Self & Family',
    biweeklyTotal: 1017.84,
    biweeklyGov: 714.23,
    biweeklyEmp: 303.61,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _113: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    option: 'Basic',
    type: 'Self Plus One',
    biweeklyTotal: 924.14,
    biweeklyGov: 650.0,
    biweeklyEmp: 274.14,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _131: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self',
    biweeklyTotal: 236.7,
    biweeklyGov: 177.53,
    biweeklyEmp: 59.17,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _132: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self & Family',
    biweeklyTotal: 559.7,
    biweeklyGov: 419.78,
    biweeklyEmp: 139.92,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _133: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self Plus One',
    biweeklyTotal: 508.86,
    biweeklyGov: 381.65,
    biweeklyEmp: 127.21,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _104: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Standard',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 472.89,
    biweeklyGov: 298.08,
    biweeklyEmp: 174.81,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _105: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Standard',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 1138.88,
    biweeklyGov: 714.23,
    biweeklyEmp: 424.65,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _106: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Standard',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 1034.14,
    biweeklyGov: 650.0,
    biweeklyEmp: 384.14,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _421: {
    name: 'Compass Rose Health Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 422.56,
    biweeklyGov: 298.08,
    biweeklyEmp: 124.48,
    link: 'http://www.compassrosebenefits.com/highsbc',
    logo: '',
  },
  _422: {
    name: 'Compass Rose Health Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1014.18,
    biweeklyGov: 714.23,
    biweeklyEmp: 299.95,
    link: 'http://www.compassrosebenefits.com/highsbc',
    logo: '',
  },
  _423: {
    name: 'Compass Rose Health Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 929.65,
    biweeklyGov: 650.0,
    biweeklyEmp: 279.65,
    link: 'http://www.compassrosebenefits.com/highsbc',
    logo: '',
  },
  _424: {
    name: 'Compass Rose Health Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 232.61,
    biweeklyGov: 174.46,
    biweeklyEmp: 58.15,
    link: 'http://www.compassrosebenefits.com/standardsbc',
    logo: '',
  },
  _425: {
    name: 'Compass Rose Health Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 558.27,
    biweeklyGov: 418.7,
    biweeklyEmp: 139.57,
    link: 'http://www.compassrosebenefits.com/standardsbc',
    logo: '',
  },
  _426: {
    name: 'Compass Rose Health Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 511.75,
    biweeklyGov: 383.81,
    biweeklyEmp: 127.94,
    link: 'http://www.compassrosebenefits.com/standardsbc',
    logo: '',
  },
  _401: {
    name: 'Foreign Service Benefit Plan ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 373.44,
    biweeklyGov: 280.08,
    biweeklyEmp: 93.36,
    link: 'https://www.afspa.org/',
    logo: '',
  },
  _402: {
    name: 'Foreign Service Benefit Plan ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 923.81,
    biweeklyGov: 692.86,
    biweeklyEmp: 230.95,
    link: 'https://www.afspa.org/',
    logo: '',
  },
  _403: {
    name: 'Foreign Service Benefit Plan ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 901.52,
    biweeklyGov: 650.0,
    biweeklyEmp: 251.52,
    link: 'https://www.afspa.org/',
    logo: '',
  },
  _311: {
    name: 'GEHA Benefit Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 435.19,
    biweeklyGov: 298.08,
    biweeklyEmp: 137.11,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _312: {
    name: 'GEHA Benefit Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1090.55,
    biweeklyGov: 714.23,
    biweeklyEmp: 376.32,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _313: {
    name: 'GEHA Benefit Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 957.42,
    biweeklyGov: 650.0,
    biweeklyEmp: 307.42,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _314: {
    name: 'GEHA Benefit Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 321.29,
    biweeklyGov: 240.97,
    biweeklyEmp: 80.32,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _315: {
    name: 'GEHA Benefit Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 857.21,
    biweeklyGov: 642.91,
    biweeklyEmp: 214.3,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _316: {
    name: 'GEHA Benefit Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 690.8,
    biweeklyGov: 518.1,
    biweeklyEmp: 172.7,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _341: {
    name: 'GEHA HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 305.1,
    biweeklyGov: 228.83,
    biweeklyEmp: 76.27,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _342: {
    name: 'GEHA HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 806.08,
    biweeklyGov: 604.56,
    biweeklyEmp: 201.52,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _343: {
    name: 'GEHA HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 655.96,
    biweeklyGov: 491.97,
    biweeklyEmp: 163.99,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _251: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate Plus',
    type: 'Self',
    biweeklyTotal: 441.57,
    biweeklyGov: 298.08,
    biweeklyEmp: 143.49,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _252: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate Plus',
    type: 'Self & Family',
    biweeklyTotal: 1061.79,
    biweeklyGov: 714.23,
    biweeklyEmp: 347.56,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _253: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate Plus',
    type: 'Self Plus One',
    biweeklyTotal: 967.29,
    biweeklyGov: 650.0,
    biweeklyEmp: 317.29,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _254: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate',
    type: 'Self',
    biweeklyTotal: 231.31,
    biweeklyGov: 173.48,
    biweeklyEmp: 57.83,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _255: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate',
    type: 'Self & Family',
    biweeklyTotal: 679.35,
    biweeklyGov: 509.51,
    biweeklyEmp: 169.84,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _256: {
    name: 'GEHA Indemnity Benefit Plan',
    option: 'Elevate',
    type: 'Self Plus One',
    biweeklyTotal: 558.03,
    biweeklyGov: 418.52,
    biweeklyEmp: 139.51,
    link: 'http://geha.com/plans/medical/2025/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _481: {
    name: 'MHBP Consumer Option',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 336.8,
    biweeklyGov: 252.6,
    biweeklyEmp: 84.2,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _482: {
    name: 'MHBP Consumer Option',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 782.59,
    biweeklyGov: 586.94,
    biweeklyEmp: 195.65,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _483: {
    name: 'MHBP Consumer Option',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 745.34,
    biweeklyGov: 559.01,
    biweeklyEmp: 186.33,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _454: {
    name: 'MHBP Standard Option',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 335.33,
    biweeklyGov: 251.5,
    biweeklyEmp: 83.83,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _455: {
    name: 'MHBP Standard Option',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 779.28,
    biweeklyGov: 584.46,
    biweeklyEmp: 194.82,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _456: {
    name: 'MHBP Standard Option',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 771.87,
    biweeklyGov: 578.9,
    biweeklyEmp: 192.97,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _414: {
    name: 'MHBP Value Plan',
    option: 'Value',
    type: 'Self',
    biweeklyTotal: 242.13,
    biweeklyGov: 181.6,
    biweeklyEmp: 60.53,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _415: {
    name: 'MHBP Value Plan',
    option: 'Value',
    type: 'Self & Family',
    biweeklyTotal: 585.17,
    biweeklyGov: 438.88,
    biweeklyEmp: 146.29,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _416: {
    name: 'MHBP Value Plan',
    option: 'Value',
    type: 'Self Plus One',
    biweeklyTotal: 573.72,
    biweeklyGov: 430.29,
    biweeklyEmp: 143.43,
    link: 'https://mhbp.com/plan-documents',
    logo: '',
  },
  _324: {
    name: 'NALC Health Benefit Plan ',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 238.71,
    biweeklyGov: 179.03,
    biweeklyEmp: 59.68,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _325: {
    name: 'NALC Health Benefit Plan ',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 585.06,
    biweeklyGov: 438.8,
    biweeklyEmp: 146.26,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _326: {
    name: 'NALC Health Benefit Plan ',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 540.49,
    biweeklyGov: 405.37,
    biweeklyEmp: 135.12,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _321: {
    name: 'NALC Health Benefit Plan ',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 434.16,
    biweeklyGov: 298.08,
    biweeklyEmp: 136.08,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _322: {
    name: 'NALC Health Benefit Plan ',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 998.17,
    biweeklyGov: 714.23,
    biweeklyEmp: 283.94,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _323: {
    name: 'NALC Health Benefit Plan ',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 968.71,
    biweeklyGov: 650.0,
    biweeklyEmp: 318.71,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _431: {
    name: 'Panama Canal Area Benefit Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 425.91,
    biweeklyGov: 298.08,
    biweeklyEmp: 127.83,
    link: 'https://www.pcabp.com.pa/members/services-1/summary-of-benefits-and-coverage.aspx',
    logo: '',
  },
  _432: {
    name: 'Panama Canal Area Benefit Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 897.35,
    biweeklyGov: 673.01,
    biweeklyEmp: 224.34,
    link: 'https://www.pcabp.com.pa/members/services-1/summary-of-benefits-and-coverage.aspx',
    logo: '',
  },
  _433: {
    name: 'Panama Canal Area Benefit Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 858.01,
    biweeklyGov: 643.51,
    biweeklyEmp: 214.5,
    link: 'https://www.pcabp.com.pa/members/services-1/summary-of-benefits-and-coverage.aspx',
    logo: '',
  },
  _441: {
    name: 'SAMBA Health Benefit Plan',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 459.05,
    biweeklyGov: 298.08,
    biweeklyEmp: 160.97,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  _442: {
    name: 'SAMBA Health Benefit Plan',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 1101.73,
    biweeklyGov: 714.23,
    biweeklyEmp: 387.5,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  _443: {
    name: 'SAMBA Health Benefit Plan',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 1009.92,
    biweeklyGov: 650.0,
    biweeklyEmp: 359.92,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  _444: {
    name: 'SAMBA Health Benefit Plan',
    option: 'Standard',
    type: 'Self',
    biweeklyTotal: 382.57,
    biweeklyGov: 286.93,
    biweeklyEmp: 95.64,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  _445: {
    name: 'SAMBA Health Benefit Plan',
    option: 'Standard',
    type: 'Self & Family',
    biweeklyTotal: 872.83,
    biweeklyGov: 654.62,
    biweeklyEmp: 218.21,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  _446: {
    name: 'SAMBA Health Benefit Plan',
    option: 'Standard',
    type: 'Self Plus One',
    biweeklyTotal: 823.43,
    biweeklyGov: 617.57,
    biweeklyEmp: 205.86,
    link: 'https://www.sambaplans.com/',
    logo: '',
  },
  L7A: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self',
    biweeklyTotal: 538.17,
    biweeklyGov: 286.09,
    biweeklyEmp: 252.08,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  L7B: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1227.1,
    biweeklyGov: 672.95,
    biweeklyEmp: 554.15,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  L7C: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1214.93,
    biweeklyGov: 618.4,
    biweeklyEmp: 596.53,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  L7D: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self',
    biweeklyTotal: 660.21,
    biweeklyGov: 286.09,
    biweeklyEmp: 374.12,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  L7E: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 1511.84,
    biweeklyGov: 672.95,
    biweeklyEmp: 838.89,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  L7F: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 1482.17,
    biweeklyGov: 618.4,
    biweeklyEmp: 863.77,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HLD: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    option: 'Aetna Advantage',
    type: 'Self',
    biweeklyTotal: 258.02,
    biweeklyGov: 193.52,
    biweeklyEmp: 64.5,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HLE: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    option: 'Aetna Advantage',
    type: 'Self & Family',
    biweeklyTotal: 683.72,
    biweeklyGov: 512.79,
    biweeklyEmp: 170.93,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HLF: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    option: 'Aetna Advantage',
    type: 'Self Plus One',
    biweeklyTotal: 567.62,
    biweeklyGov: 425.72,
    biweeklyEmp: 141.9,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3A: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna Direct',
    type: 'Self',
    biweeklyTotal: 303.7,
    biweeklyGov: 227.78,
    biweeklyEmp: 75.92,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3B: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna Direct',
    type: 'Self & Family',
    biweeklyTotal: 765.91,
    biweeklyGov: 574.43,
    biweeklyEmp: 191.48,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3C: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna Direct',
    type: 'Self Plus One',
    biweeklyTotal: 666.05,
    biweeklyGov: 499.54,
    biweeklyEmp: 166.51,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3D: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna HealthFund HDHP',
    type: 'Self',
    biweeklyTotal: 460.47,
    biweeklyGov: 286.09,
    biweeklyEmp: 174.38,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3E: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna HealthFund HDHP',
    type: 'Self & Family',
    biweeklyTotal: 1015.71,
    biweeklyGov: 672.95,
    biweeklyEmp: 342.76,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G3F: {
    name: 'Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    option: 'Aetna HealthFund HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 995.82,
    biweeklyGov: 618.4,
    biweeklyEmp: 377.42,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JYA: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 398.94,
    biweeklyGov: 286.09,
    biweeklyEmp: 112.85,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  JYB: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 943.53,
    biweeklyGov: 672.95,
    biweeklyEmp: 270.58,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  JYC: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 857.75,
    biweeklyGov: 618.4,
    biweeklyEmp: 239.35,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  JDA: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self',
    biweeklyTotal: 757.48,
    biweeklyGov: 286.09,
    biweeklyEmp: 471.39,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JDB: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1726.74,
    biweeklyGov: 672.95,
    biweeklyEmp: 1053.79,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JDC: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1709.64,
    biweeklyGov: 618.4,
    biweeklyEmp: 1091.24,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JDD: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self',
    biweeklyTotal: 611.38,
    biweeklyGov: 286.09,
    biweeklyEmp: 325.29,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JDE: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 1395.7,
    biweeklyGov: 672.95,
    biweeklyEmp: 722.75,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  JDF: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 1381.91,
    biweeklyGov: 618.4,
    biweeklyEmp: 763.51,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRA: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self',
    biweeklyTotal: 730.38,
    biweeklyGov: 286.09,
    biweeklyEmp: 444.29,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRB: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1666.02,
    biweeklyGov: 672.95,
    biweeklyEmp: 993.07,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRC: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1649.54,
    biweeklyGov: 618.4,
    biweeklyEmp: 1031.14,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRD: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self',
    biweeklyTotal: 555.35,
    biweeklyGov: 286.09,
    biweeklyEmp: 269.26,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRE: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 1271.92,
    biweeklyGov: 672.95,
    biweeklyEmp: 598.97,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  GRF: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 1247,
    biweeklyGov: 618.4,
    biweeklyEmp: 628.6,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KEA: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 378.48,
    biweeklyGov: 283.86,
    biweeklyEmp: 94.62,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  KEB: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 895.08,
    biweeklyGov: 671.31,
    biweeklyEmp: 223.77,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  KEC: {
    name: 'UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 813.72,
    biweeklyGov: 610.29,
    biweeklyEmp: 203.43,
    link: 'http://uhcfeds.com',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  NNA: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 430.55,
    biweeklyGov: 286.09,
    biweeklyEmp: 144.46,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NNB: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 995.08,
    biweeklyGov: 672.95,
    biweeklyEmp: 322.13,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NNC: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 995.08,
    biweeklyGov: 618.4,
    biweeklyEmp: 376.68,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NND: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 325.47,
    biweeklyGov: 244.1,
    biweeklyEmp: 81.37,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NNE: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 752.21,
    biweeklyGov: 564.16,
    biweeklyEmp: 188.05,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NNF: {
    name: 'Kaiser Permanente - Fresno California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 752.21,
    biweeklyGov: 564.16,
    biweeklyEmp: 188.05,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBA: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 476.86,
    biweeklyGov: 286.09,
    biweeklyEmp: 190.77,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBB: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 1138.31,
    biweeklyGov: 672.95,
    biweeklyEmp: 465.36,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBC: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 1138.31,
    biweeklyGov: 618.4,
    biweeklyEmp: 519.91,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBD: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 384.39,
    biweeklyGov: 286.09,
    biweeklyEmp: 98.3,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBE: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 899.5,
    biweeklyGov: 672.95,
    biweeklyEmp: 226.55,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  TBF: {
    name: 'Kaiser Permanente - Northern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 899.5,
    biweeklyGov: 618.4,
    biweeklyEmp: 281.1,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UDA: {
    name: 'Kaiser Permanente - Northern California - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 317.08,
    biweeklyGov: 237.81,
    biweeklyEmp: 79.27,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UDB: {
    name: 'Kaiser Permanente - Northern California - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 741.96,
    biweeklyGov: 556.47,
    biweeklyEmp: 185.49,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UDC: {
    name: 'Kaiser Permanente - Northern California - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 741.96,
    biweeklyGov: 556.47,
    biweeklyEmp: 185.49,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3A: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 383.88,
    biweeklyGov: 286.09,
    biweeklyEmp: 97.79,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3B: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 887.23,
    biweeklyGov: 665.42,
    biweeklyEmp: 221.81,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3C: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 887.23,
    biweeklyGov: 618.4,
    biweeklyEmp: 268.83,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3D: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 279.44,
    biweeklyGov: 209.58,
    biweeklyEmp: 69.86,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3E: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 676.05,
    biweeklyGov: 507.04,
    biweeklyEmp: 169.01,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  Y3F: {
    name: 'Kaiser Permanente - Southern California - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 617.57,
    biweeklyGov: 463.18,
    biweeklyEmp: 154.39,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  MBA: {
    name: 'Kaiser Permanente - Southern California - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 183.07,
    biweeklyGov: 137.3,
    biweeklyEmp: 45.77,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  MBB: {
    name: 'Kaiser Permanente - Southern California - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 512.61,
    biweeklyGov: 384.46,
    biweeklyEmp: 128.15,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  MBC: {
    name: 'Kaiser Permanente - Southern California - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 421.06,
    biweeklyGov: 315.8,
    biweeklyEmp: 105.26,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8A: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 383.3,
    biweeklyGov: 286.09,
    biweeklyEmp: 97.21,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8B: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 942.93,
    biweeklyGov: 672.95,
    biweeklyEmp: 269.98,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8C: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 866.26,
    biweeklyGov: 618.4,
    biweeklyEmp: 247.86,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8D: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 299.42,
    biweeklyGov: 224.57,
    biweeklyEmp: 74.85,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8E: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 736.57,
    biweeklyGov: 552.43,
    biweeklyEmp: 184.14,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  M8F: {
    name: 'Kaiser Permanente - Colorado - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 676.68,
    biweeklyGov: 507.51,
    biweeklyEmp: 169.17,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NCA: {
    name: 'Kaiser Permanente - Colorado - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 197.3,
    biweeklyGov: 147.98,
    biweeklyEmp: 49.32,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NCB: {
    name: 'Kaiser Permanente - Colorado - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 485.35,
    biweeklyGov: 364.01,
    biweeklyEmp: 121.34,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NCC: {
    name: 'Kaiser Permanente - Colorado - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 445.89,
    biweeklyGov: 334.42,
    biweeklyEmp: 111.47,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  KDA: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self',
    biweeklyTotal: 671.73,
    biweeklyGov: 286.09,
    biweeklyEmp: 385.64,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KDB: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1531.88,
    biweeklyGov: 672.95,
    biweeklyEmp: 858.93,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KDC: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1516.72,
    biweeklyGov: 618.4,
    biweeklyEmp: 898.32,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KDD: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self',
    biweeklyTotal: 639.11,
    biweeklyGov: 286.09,
    biweeklyEmp: 353.02,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KDE: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 1463.5,
    biweeklyGov: 672.95,
    biweeklyEmp: 790.55,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  KDF: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 1434.76,
    biweeklyGov: 618.4,
    biweeklyEmp: 816.36,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HXD: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    option: 'Aetna Saver ',
    type: 'Self',
    biweeklyTotal: 276.26,
    biweeklyGov: 207.2,
    biweeklyEmp: 69.06,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HXE: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    option: 'Aetna Saver ',
    type: 'Self & Family',
    biweeklyTotal: 632.22,
    biweeklyGov: 474.17,
    biweeklyEmp: 158.05,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HXF: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    option: 'Aetna Saver ',
    type: 'Self Plus One',
    biweeklyTotal: 580.56,
    biweeklyGov: 435.42,
    biweeklyEmp: 145.14,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8A: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - High Option ',
    type: 'Self',
    biweeklyTotal: 674.56,
    biweeklyGov: 286.09,
    biweeklyEmp: 388.47,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8B: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - High Option ',
    type: 'Self & Family',
    biweeklyTotal: 1516.52,
    biweeklyGov: 672.95,
    biweeklyEmp: 843.57,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8C: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - High Option ',
    type: 'Self Plus One',
    biweeklyTotal: 1501.48,
    biweeklyGov: 618.4,
    biweeklyEmp: 883.08,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8D: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - Basic Option',
    type: 'Self',
    biweeklyTotal: 395.23,
    biweeklyGov: 286.09,
    biweeklyEmp: 109.14,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8E: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - Basic Option',
    type: 'Self & Family',
    biweeklyTotal: 904.47,
    biweeklyGov: 672.95,
    biweeklyEmp: 231.52,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  G8F: {
    name: 'Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    option: 'Aetna Open Access - Basic Option',
    type: 'Self Plus One',
    biweeklyTotal: 830.54,
    biweeklyGov: 618.4,
    biweeklyEmp: 212.14,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  K4A: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 335.32,
    biweeklyGov: 251.49,
    biweeklyEmp: 83.83,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  K4B: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 796.69,
    biweeklyGov: 597.52,
    biweeklyEmp: 199.17,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  K4C: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 670.62,
    biweeklyGov: 502.97,
    biweeklyEmp: 167.65,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  K4D: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'Blue Value Plus',
    type: 'Self',
    biweeklyTotal: 357.71,
    biweeklyGov: 268.28,
    biweeklyEmp: 89.43,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  K4E: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'Blue Value Plus',
    type: 'Self & Family',
    biweeklyTotal: 849.9,
    biweeklyGov: 637.43,
    biweeklyEmp: 212.47,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  K4F: {
    name: 'CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    option: 'Blue Value Plus',
    type: 'Self Plus One',
    biweeklyTotal: 715.42,
    biweeklyGov: 536.57,
    biweeklyEmp: 178.85,
    link: 'https://member.carefirst.com/members/home.page',
    logo: '',
  },
  RAA: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 398.95,
    biweeklyGov: 286.09,
    biweeklyEmp: 112.86,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: '',
  },
  RAB: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 917.6,
    biweeklyGov: 672.95,
    biweeklyEmp: 244.65,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  RAC: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 917.6,
    biweeklyGov: 618.4,
    biweeklyEmp: 299.2,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  RAD: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 312,
    biweeklyGov: 234,
    biweeklyEmp: 78,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  RAE: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 717.6,
    biweeklyGov: 538.2,
    biweeklyEmp: 179.4,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  RAF: {
    name: 'Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 717.6,
    biweeklyGov: 538.2,
    biweeklyEmp: 179.4,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NWA: {
    name: 'Kaiser Permanente - Mid-Atlantic States - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 201.26,
    biweeklyGov: 150.95,
    biweeklyEmp: 50.31,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NWB: {
    name: 'Kaiser Permanente - Mid-Atlantic States - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 566.24,
    biweeklyGov: 424.68,
    biweeklyEmp: 141.56,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  NWC: {
    name: 'Kaiser Permanente - Mid-Atlantic States - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 480.82,
    biweeklyGov: 360.62,
    biweeklyEmp: 120.2,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFA: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 420.69,
    biweeklyGov: 286.09,
    biweeklyEmp: 134.6,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFB: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 950.77,
    biweeklyGov: 672.95,
    biweeklyEmp: 277.82,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFC: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 950.77,
    biweeklyGov: 618.4,
    biweeklyEmp: 332.37,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFD: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 315.39,
    biweeklyGov: 236.54,
    biweeklyEmp: 78.85,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFE: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 712.78,
    biweeklyGov: 534.59,
    biweeklyEmp: 178.19,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PFF: {
    name: 'Kaiser Permanente - Georgia - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 712.78,
    biweeklyGov: 534.59,
    biweeklyEmp: 178.19,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  QZA: {
    name: 'Kaiser Permanente - Georgia - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 237.31,
    biweeklyGov: 177.98,
    biweeklyEmp: 59.33,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  QZB: {
    name: 'Kaiser Permanente - Georgia - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 616.11,
    biweeklyGov: 462.08,
    biweeklyEmp: 154.03,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  QZC: {
    name: 'Kaiser Permanente - Georgia - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 536.32,
    biweeklyGov: 402.24,
    biweeklyEmp: 134.08,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  HJA: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    option: 'HDHP Option',
    type: 'Self',
    biweeklyTotal: 64.47,
    biweeklyGov: 48.35,
    biweeklyEmp: 16.12,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  HJB: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    option: 'HDHP Option',
    type: 'Self & Family',
    biweeklyTotal: 172.84,
    biweeklyGov: 129.63,
    biweeklyEmp: 43.21,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  HJC: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    option: 'HDHP Option',
    type: 'Self Plus One',
    biweeklyTotal: 155.63,
    biweeklyGov: 116.72,
    biweeklyEmp: 38.91,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4A: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 263.18,
    biweeklyGov: 197.39,
    biweeklyEmp: 65.79,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4B: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 756.63,
    biweeklyGov: 567.47,
    biweeklyEmp: 189.16,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4C: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 526.16,
    biweeklyGov: 394.62,
    biweeklyEmp: 131.54,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4D: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 189.83,
    biweeklyGov: 142.37,
    biweeklyEmp: 47.46,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4E: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 626.54,
    biweeklyGov: 469.91,
    biweeklyEmp: 156.63,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  G4F: {
    name: 'TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 380.36,
    biweeklyGov: 285.27,
    biweeklyEmp: 95.09,
    link: 'https://www.takecareasia.com/',
    logo: '',
  },
  M6A: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'High Option Plan',
    type: 'Self',
    biweeklyTotal: 358.49,
    biweeklyGov: 268.87,
    biweeklyEmp: 89.62,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  M6B: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'High Option Plan',
    type: 'Self & Family',
    biweeklyTotal: 805.89,
    biweeklyGov: 604.42,
    biweeklyEmp: 201.47,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  M6C: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'High Option Plan',
    type: 'Self Plus One',
    biweeklyTotal: 785.48,
    biweeklyGov: 589.11,
    biweeklyEmp: 196.37,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  M6D: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'Standard Option Plan',
    type: 'Self',
    biweeklyTotal: 235.33,
    biweeklyGov: 176.5,
    biweeklyEmp: 58.83,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  M6E: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'Standard Option Plan',
    type: 'Self & Family',
    biweeklyTotal: 529,
    biweeklyGov: 396.75,
    biweeklyEmp: 132.25,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  M6F: {
    name: 'HMSA Plan - HMSA Plan for Postal Service Employees',
    option: 'Standard Option Plan',
    type: 'Self Plus One',
    biweeklyTotal: 515.58,
    biweeklyGov: 386.69,
    biweeklyEmp: 128.89,
    link: 'https://www.hmsa.com/employer/postal/',
    logo: '',
  },
  PKA: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'High Option ',
    type: 'Self',
    biweeklyTotal: 303.21,
    biweeklyGov: 227.41,
    biweeklyEmp: 75.8,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PKB: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'High Option ',
    type: 'Self & Family',
    biweeklyTotal: 682.23,
    biweeklyGov: 511.67,
    biweeklyEmp: 170.56,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PKC: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'High Option ',
    type: 'Self Plus One',
    biweeklyTotal: 664.04,
    biweeklyGov: 498.03,
    biweeklyEmp: 166.01,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PKD: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 218.39,
    biweeklyGov: 163.79,
    biweeklyEmp: 54.6,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PKE: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 491.39,
    biweeklyGov: 368.54,
    biweeklyEmp: 122.85,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PKF: {
    name: 'Kaiser Permanente - Hawaii - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 478.28,
    biweeklyGov: 358.71,
    biweeklyEmp: 119.57,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  HHA: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self',
    biweeklyTotal: 472.33,
    biweeklyGov: 286.09,
    biweeklyEmp: 186.24,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HHB: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self & Family',
    biweeklyTotal: 1076.63,
    biweeklyGov: 672.95,
    biweeklyEmp: 403.68,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HHC: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna HealthFund CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 1066.2,
    biweeklyGov: 618.4,
    biweeklyEmp: 447.8,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HHD: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self',
    biweeklyTotal: 623.45,
    biweeklyGov: 286.09,
    biweeklyEmp: 337.36,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HHE: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 1430.77,
    biweeklyGov: 672.95,
    biweeklyEmp: 757.82,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  HHF: {
    name: 'Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    option: 'Aetna Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 1402.72,
    biweeklyGov: 618.4,
    biweeklyEmp: 784.32,
    link: 'http://www.aetnafeds.com/sbc.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  DWD: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 183.61,
    biweeklyGov: 137.71,
    biweeklyEmp: 45.9,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  DWE: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 514.1,
    biweeklyGov: 385.58,
    biweeklyEmp: 128.52,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  DWF: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 444.74,
    biweeklyGov: 333.56,
    biweeklyEmp: 111.18,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRA: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'High Option ',
    type: 'Self',
    biweeklyTotal: 471.84,
    biweeklyGov: 286.09,
    biweeklyEmp: 185.75,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRB: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'High Option ',
    type: 'Self & Family',
    biweeklyTotal: 1038.06,
    biweeklyGov: 672.95,
    biweeklyEmp: 365.11,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRC: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'High Option ',
    type: 'Self Plus One',
    biweeklyTotal: 1038.06,
    biweeklyGov: 618.4,
    biweeklyEmp: 419.66,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRD: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Standard Option ',
    type: 'Self',
    biweeklyTotal: 325.1,
    biweeklyGov: 243.83,
    biweeklyEmp: 81.27,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRE: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Standard Option ',
    type: 'Self & Family',
    biweeklyTotal: 747.73,
    biweeklyGov: 560.8,
    biweeklyEmp: 186.93,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  PRF: {
    name: 'Kaiser Permanente - Washington Core - Washington Core',
    option: 'Standard Option ',
    type: 'Self Plus One',
    biweeklyTotal: 747.73,
    biweeklyGov: 560.8,
    biweeklyEmp: 186.93,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  KGA: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 383.33,
    biweeklyGov: 286.09,
    biweeklyEmp: 97.24,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  KGB: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 933.8,
    biweeklyGov: 672.95,
    biweeklyEmp: 260.85,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  KGC: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 847.16,
    biweeklyGov: 618.4,
    biweeklyEmp: 228.76,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  KGD: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 255.36,
    biweeklyGov: 191.52,
    biweeklyEmp: 63.84,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  KGE: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 622.08,
    biweeklyGov: 466.56,
    biweeklyEmp: 155.52,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  KGF: {
    name: 'HealthPartners - HealthPartners High/Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 564.36,
    biweeklyGov: 423.27,
    biweeklyEmp: 141.09,
    link: 'http://www.healthpartners.com/fehb',
    logo: '',
  },
  J5A: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial High Option',
    type: 'Self',
    biweeklyTotal: 499.57,
    biweeklyGov: 286.09,
    biweeklyEmp: 213.48,
    link: 'https://www.hap.org/',
    logo: '',
  },
  J5B: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial High Option',
    type: 'Self & Family',
    biweeklyTotal: 1218.96,
    biweeklyGov: 672.95,
    biweeklyEmp: 546.01,
    link: 'https://www.hap.org/',
    logo: '',
  },
  J5C: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial High Option',
    type: 'Self Plus One',
    biweeklyTotal: 1149.02,
    biweeklyGov: 618.4,
    biweeklyEmp: 530.62,
    link: 'https://www.hap.org/',
    logo: '',
  },
  J5D: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial Standard Option',
    type: 'Self',
    biweeklyTotal: 300.81,
    biweeklyGov: 225.61,
    biweeklyEmp: 75.2,
    link: 'https://www.hap.org/',
    logo: '',
  },
  J5E: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 733.97,
    biweeklyGov: 550.48,
    biweeklyEmp: 183.49,
    link: 'https://www.hap.org/',
    logo: '',
  },
  J5F: {
    name: 'Health Alliance Plan of Michigan - PSHB  High & Standard',
    option: 'Commercial Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 691.86,
    biweeklyGov: 518.9,
    biweeklyEmp: 172.96,
    link: 'https://www.hap.org/',
    logo: '',
  },
  D3A: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Basic Option',
    type: 'Self',
    biweeklyTotal: 199.56,
    biweeklyGov: 149.67,
    biweeklyEmp: 49.89,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  D3B: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Basic Option',
    type: 'Self & Family',
    biweeklyTotal: 478.94,
    biweeklyGov: 359.21,
    biweeklyEmp: 119.73,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  D3C: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Basic Option',
    type: 'Self Plus One',
    biweeklyTotal: 439.03,
    biweeklyGov: 329.27,
    biweeklyEmp: 109.76,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  D3D: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 570.72,
    biweeklyGov: 286.09,
    biweeklyEmp: 284.63,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  D3E: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 1369.74,
    biweeklyGov: 672.95,
    biweeklyEmp: 696.79,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  D3F: {
    name: 'Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 1255.59,
    biweeklyGov: 618.4,
    biweeklyEmp: 637.19,
    link: 'https://www.medmutual.com/',
    logo: '',
  },
  UZA: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 369.68,
    biweeklyGov: 277.26,
    biweeklyEmp: 92.42,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UZB: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 879.83,
    biweeklyGov: 659.87,
    biweeklyEmp: 219.96,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UZC: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 798.5,
    biweeklyGov: 598.88,
    biweeklyEmp: 199.62,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UZD: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 315.22,
    biweeklyGov: 236.42,
    biweeklyEmp: 78.8,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UZE: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 750.24,
    biweeklyGov: 562.68,
    biweeklyEmp: 187.56,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  UZF: {
    name: 'Kaiser Permanente - Northwest - High and Standard Option',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 680.88,
    biweeklyGov: 510.66,
    biweeklyEmp: 170.22,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  YRA: {
    name: 'Kaiser Permanente - Northwest - Prosper',
    option: 'Prosper',
    type: 'Self',
    biweeklyTotal: 179.51,
    biweeklyGov: 134.63,
    biweeklyEmp: 44.88,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  YRB: {
    name: 'Kaiser Permanente - Northwest - Prosper',
    option: 'Prosper',
    type: 'Self & Family',
    biweeklyTotal: 448.79,
    biweeklyGov: 336.59,
    biweeklyEmp: 112.2,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  YRC: {
    name: 'Kaiser Permanente - Northwest - Prosper',
    option: 'Prosper',
    type: 'Self Plus One',
    biweeklyTotal: 387.76,
    biweeklyGov: 290.82,
    biweeklyEmp: 96.94,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  G9A: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'High Deductible Health Plan (HDHP) Option',
    type: 'Self',
    biweeklyTotal: 221.31,
    biweeklyGov: 165.98,
    biweeklyEmp: 55.33,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  G9B: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'High Deductible Health Plan (HDHP) Option',
    type: 'Self & Family',
    biweeklyTotal: 577.99,
    biweeklyGov: 433.49,
    biweeklyEmp: 144.5,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  G9C: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'High Deductible Health Plan (HDHP) Option',
    type: 'Self Plus One',
    biweeklyTotal: 521.94,
    biweeklyGov: 391.46,
    biweeklyEmp: 130.48,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  G9D: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 303.92,
    biweeklyGov: 227.94,
    biweeklyEmp: 75.98,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  G9E: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 829.03,
    biweeklyGov: 621.77,
    biweeklyEmp: 207.26,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  G9F: {
    name: 'UPMC Health Plan - UPMC Health Plan',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 740.66,
    biweeklyGov: 555.5,
    biweeklyEmp: 185.16,
    link: 'https://www.upmchealthplan.com/',
    logo: '',
  },
  _83A: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 215.36,
    biweeklyGov: 161.52,
    biweeklyEmp: 53.84,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  _83B: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 493.19,
    biweeklyGov: 369.89,
    biweeklyEmp: 123.3,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  _83C: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 483.57,
    biweeklyGov: 362.68,
    biweeklyEmp: 120.89,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  _14A: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self',
    biweeklyTotal: 300.99,
    biweeklyGov: 225.74,
    biweeklyEmp: 75.25,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  _14B: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self & Family',
    biweeklyTotal: 689.27,
    biweeklyGov: 516.95,
    biweeklyEmp: 172.32,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  _14C: {
    name: 'Triple-S Salud, Inc - Triple-S Salud',
    option: 'High',
    type: 'Self Plus One',
    biweeklyTotal: 675.81,
    biweeklyGov: 506.86,
    biweeklyEmp: 168.95,
    link: 'https://salud.grupotriples.com/en/',
    logo: '',
  },
  H9A: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 326.11,
    biweeklyGov: 244.58,
    biweeklyEmp: 81.53,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H9B: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 723.96,
    biweeklyGov: 542.97,
    biweeklyEmp: 180.99,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H9C: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 723.96,
    biweeklyGov: 542.97,
    biweeklyEmp: 180.99,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H9D: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'HDHP',
    type: 'Self',
    biweeklyTotal: 287.84,
    biweeklyGov: 215.88,
    biweeklyEmp: 71.96,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H9E: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'HDHP',
    type: 'Self & Family',
    biweeklyTotal: 638.98,
    biweeklyGov: 479.24,
    biweeklyEmp: 159.74,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  H9F: {
    name: 'Kaiser Permanente Washington Options Federal - Standard and HDHP',
    option: 'HDHP',
    type: 'Self Plus One',
    biweeklyTotal: 638.98,
    biweeklyGov: 479.24,
    biweeklyEmp: 159.74,
    link: 'https://healthplans.kaiserpermanente.org/federal-employees-fehb/tools-resources/brochures-forms/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/KP_logo.svg',
  },
  _23A: {
    name: 'APWU Health Plan',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 395.95,
    biweeklyGov: 286.09,
    biweeklyEmp: 109.86,
    link: 'https://apwu.org/health-plan-0',
    logo: '',
  },
  _23B: {
    name: 'APWU Health Plan',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 950.23,
    biweeklyGov: 672.95,
    biweeklyEmp: 277.28,
    link: 'https://apwu.org/health-plan-1',
    logo: '',
  },
  _23C: {
    name: 'APWU Health Plan',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 831.45,
    biweeklyGov: 618.4,
    biweeklyEmp: 213.05,
    link: 'https://apwu.org/health-plan-2',
    logo: '',
  },
  _23D: {
    name: 'APWU Health Plan',
    option: 'Consumer Driven Option',
    type: 'Self',
    biweeklyTotal: 322.49,
    biweeklyGov: 241.87,
    biweeklyEmp: 80.62,
    link: 'https://apwu.org/health-plan-3',
    logo: '',
  },
  _23E: {
    name: 'APWU Health Plan',
    option: 'Consumer Driven Option',
    type: 'Self & Family',
    biweeklyTotal: 764.63,
    biweeklyGov: 573.47,
    biweeklyEmp: 191.16,
    link: 'https://apwu.org/health-plan-4',
    logo: '',
  },
  _23F: {
    name: 'APWU Health Plan',
    option: 'Consumer Driven Option',
    type: 'Self Plus One',
    biweeklyTotal: 700.91,
    biweeklyGov: 525.68,
    biweeklyEmp: 175.23,
    link: 'https://apwu.org/health-plan-5',
    logo: '',
  },
  _33A: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Basic Option',
    type: 'Self',
    biweeklyTotal: 400.21,
    biweeklyGov: 286.09,
    biweeklyEmp: 114.12,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _33B: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Basic Option',
    type: 'Self & Family',
    biweeklyTotal: 990.57,
    biweeklyGov: 672.95,
    biweeklyEmp: 317.62,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _33C: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Basic Option',
    type: 'Self Plus One',
    biweeklyTotal: 899.39,
    biweeklyGov: 618.4,
    biweeklyEmp: 280.99,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _33D: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 460.22,
    biweeklyGov: 286.09,
    biweeklyEmp: 174.13,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _33E: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 1108.38,
    biweeklyGov: 672.95,
    biweeklyEmp: 435.43,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _33F: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 1006.44,
    biweeklyGov: 618.4,
    biweeklyEmp: 388.04,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _35A: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self',
    biweeklyTotal: 236.7,
    biweeklyGov: 177.53,
    biweeklyEmp: 59.17,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _35B: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self & Family',
    biweeklyTotal: 559.7,
    biweeklyGov: 419.78,
    biweeklyEmp: 139.92,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _35C: {
    name: 'Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    option: 'FEP Blue Focus',
    type: 'Self Plus One',
    biweeklyTotal: 508.86,
    biweeklyGov: 381.65,
    biweeklyEmp: 127.21,
    link: 'https://www.fepblue.org/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  _39A: {
    name: 'GEHA Benefit Plan - HDHP',
    option: 'High Deductible Health Plan',
    type: 'Self',
    biweeklyTotal: 314.39,
    biweeklyGov: 235.79,
    biweeklyEmp: 78.6,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _39B: {
    name: 'GEHA Benefit Plan - HDHP',
    option: 'High Deductible Health Plan',
    type: 'Self & Family',
    biweeklyTotal: 830.63,
    biweeklyGov: 622.97,
    biweeklyEmp: 207.66,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _39C: {
    name: 'GEHA Benefit Plan - HDHP',
    option: 'High Deductible Health Plan',
    type: 'Self Plus One',
    biweeklyTotal: 675.94,
    biweeklyGov: 506.96,
    biweeklyEmp: 168.98,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37A: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 414.28,
    biweeklyGov: 286.09,
    biweeklyEmp: 128.19,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37B: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 1038.17,
    biweeklyGov: 672.95,
    biweeklyEmp: 365.22,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37C: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 911.44,
    biweeklyGov: 618.4,
    biweeklyEmp: 293.04,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37D: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'Standard Option',
    type: 'Self',
    biweeklyTotal: 297.44,
    biweeklyGov: 223.08,
    biweeklyEmp: 74.36,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37E: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'Standard Option',
    type: 'Self & Family',
    biweeklyTotal: 790.13,
    biweeklyGov: 592.6,
    biweeklyEmp: 197.53,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _37F: {
    name: 'GEHA Benefit Plan - High and Standard',
    option: 'Standard Option',
    type: 'Self Plus One',
    biweeklyTotal: 639.52,
    biweeklyGov: 479.64,
    biweeklyEmp: 159.88,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58A: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Plus Option',
    type: 'Self',
    biweeklyTotal: 448.78,
    biweeklyGov: 286.09,
    biweeklyEmp: 162.69,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58B: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Plus Option',
    type: 'Self & Family',
    biweeklyTotal: 1079.11,
    biweeklyGov: 672.95,
    biweeklyEmp: 406.16,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58C: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Plus Option',
    type: 'Self Plus One',
    biweeklyTotal: 983.07,
    biweeklyGov: 618.4,
    biweeklyEmp: 364.67,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58D: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Option',
    type: 'Self',
    biweeklyTotal: 272.55,
    biweeklyGov: 204.41,
    biweeklyEmp: 68.14,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58E: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Option',
    type: 'Self & Family',
    biweeklyTotal: 800.49,
    biweeklyGov: 600.37,
    biweeklyEmp: 200.12,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _58F: {
    name: 'GEHA Indemnity - Elevate Plus and Elevate',
    option: 'Elevate Option',
    type: 'Self Plus One',
    biweeklyTotal: 657.54,
    biweeklyGov: 493.16,
    biweeklyEmp: 164.38,
    link: 'https://www.geha.com/plans/medical/2025/pshb/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  _74A: {
    name: 'MHBP Consumer Option',
    option: 'Consumer Option',
    type: 'Self',
    biweeklyTotal: 377.73,
    biweeklyGov: 283.3,
    biweeklyEmp: 94.43,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _74B: {
    name: 'MHBP Consumer Option',
    option: 'Consumer Option',
    type: 'Self & Family',
    biweeklyTotal: 877.67,
    biweeklyGov: 658.25,
    biweeklyEmp: 219.42,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _74C: {
    name: 'MHBP Consumer Option',
    option: 'Consumer Option',
    type: 'Self Plus One',
    biweeklyTotal: 835.89,
    biweeklyGov: 618.4,
    biweeklyEmp: 217.49,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73A: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Value Plan',
    type: 'Self',
    biweeklyTotal: 251.45,
    biweeklyGov: 188.59,
    biweeklyEmp: 62.86,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73B: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Value Plan',
    type: 'Self & Family',
    biweeklyTotal: 607.67,
    biweeklyGov: 455.75,
    biweeklyEmp: 151.92,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73C: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Value Plan',
    type: 'Self Plus One',
    biweeklyTotal: 595.77,
    biweeklyGov: 446.83,
    biweeklyEmp: 148.94,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73D: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Standard Option ',
    type: 'Self',
    biweeklyTotal: 328.88,
    biweeklyGov: 246.66,
    biweeklyEmp: 82.22,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73E: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Standard Option ',
    type: 'Self & Family',
    biweeklyTotal: 764.3,
    biweeklyGov: 573.23,
    biweeklyEmp: 191.07,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _73F: {
    name: 'MHBP Standard and Value Option',
    option: 'MHBP Standard Option ',
    type: 'Self Plus One',
    biweeklyTotal: 757.03,
    biweeklyGov: 567.77,
    biweeklyEmp: 189.26,
    link: 'https://mhbp.com/medicalplans/',
    logo: '',
  },
  _77A: {
    name: 'NALC Health Benefit Plan',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 396.07,
    biweeklyGov: 286.09,
    biweeklyEmp: 109.98,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _77B: {
    name: 'NALC Health Benefit Plan',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 911.37,
    biweeklyGov: 672.95,
    biweeklyEmp: 238.42,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _77C: {
    name: 'NALC Health Benefit Plan',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 884.48,
    biweeklyGov: 618.4,
    biweeklyEmp: 266.08,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _77D: {
    name: 'NALC Health Benefit Plan',
    option: 'CDHP',
    type: 'Self',
    biweeklyTotal: 236.51,
    biweeklyGov: 177.38,
    biweeklyEmp: 59.13,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _77E: {
    name: 'NALC Health Benefit Plan',
    option: 'CDHP',
    type: 'Self & Family',
    biweeklyTotal: 579.7,
    biweeklyGov: 434.78,
    biweeklyEmp: 144.92,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _77F: {
    name: 'NALC Health Benefit Plan',
    option: 'CDHP',
    type: 'Self Plus One',
    biweeklyTotal: 535.54,
    biweeklyGov: 401.66,
    biweeklyEmp: 133.88,
    link: 'https://www.nalchbp.org/',
    logo: '',
  },
  _79A: {
    name: 'Rural Carrier Benefit Plan',
    option: 'High Option',
    type: 'Self',
    biweeklyTotal: 432.6,
    biweeklyGov: 286.09,
    biweeklyEmp: 146.51,
    link: 'https://rcbphealth.com/',
    logo: '',
  },
  _79B: {
    name: 'Rural Carrier Benefit Plan',
    option: 'High Option',
    type: 'Self & Family',
    biweeklyTotal: 946.32,
    biweeklyGov: 672.95,
    biweeklyEmp: 273.37,
    link: 'https://rcbphealth.com/',
    logo: '',
  },
  _79C: {
    name: 'Rural Carrier Benefit Plan',
    option: 'High Option',
    type: 'Self Plus One',
    biweeklyTotal: 900.93,
    biweeklyGov: 618.4,
    biweeklyEmp: 282.53,
    link: 'https://rcbphealth.com/',
    logo: '',
  },
}
